import sha256 from 'js-sha256';

class ga4 {
  constructor() {
    this.htmlElement = document.documentElement;
    this.bodyElement = document.querySelector('body');
    this.purchaseConfirmationMessage = document.querySelector('.page-node-type-detaillant .webform-confirmation__message');
    this.retailerSelector = document.querySelector('.page-node-type-detaillant .choose-retailer-section .retailer__selector');
    this.retailerDetail = document.querySelector('.page-node-type-detaillant .detaillant-contact');
    this.retailerSearchBlock = document.querySelector('.block-retailer-search');
    this.applyFacetsBtn = document.querySelector('.facets-selector-content .facets-apply-button');
    this.facetsSummaryItems = document.querySelectorAll('.block-facets-summary span.facet-item__value');
    this.checkedCheckboxes = document.querySelectorAll('.facets-selector-content input[type="checkbox"]:checked');
    this.searchSuggestions = document.querySelectorAll('.suggestion-section .field__item a');
    this.ctabuttonElements = document.querySelectorAll('.paragraph--type--media-block a, .paragraph--type--jumbotron-avec-image-horizontale a, .paragraph--type--related-content a, .paragraph--type--jumbotron-avec-image-expert a, .node--type-hub-nouvelles .wrapper-super-vedette .rich-text__body a, .paragraph--type--jumbotron-avec-image-horizontale a, .paragraph--type--pods a, .paragraph--type--cards a, .paragraph--type--rich-text a, .paragraph--type--video .video__cta a, .view-sollio-biographie a, .paragraph--type--icones-de-statistique a, .paragraph--type--tiles a, .node--type-detaillant .detaillant-about a, .node--type-detaillant .contact-info-btn');
    this.provinceSelector = document.querySelectorAll('#block-solliocustomchooseprovinceblock .provinceSelector .province_input');
    this.provinceSelectorMain = document.querySelector('.block-sollio-custom-blocks-top-header .currentProvinceLabel');
    this.findRetailer = document.querySelectorAll('.block-sollio-custom-blocks-top-header .currentRetailerLabel');
    this.findRetailerPanel = document.querySelector('.block-sollio-custom-blocks-choose-retailer .retailer-selector-content');
    this.viewFolderPage = document.querySelector('.block-views-blocksollio-bookmark-page');
    this.viewFolderCLick = document.querySelectorAll('.my-folder-toggle');
    this.addtoFolderBtn = document.querySelectorAll('.js-action-bookmark');
    this.addtoWishListBtn = document.querySelector('.node--type-detaillant .choose-retailer-section');
    this.viewRetailerPage = document.querySelector('.node--type-detaillant');
    this.retailerForm = document.querySelector('.node--type-detaillant .webform-submission-form');
    this.fileDownloadPDF = document.querySelectorAll('.js-print-selector');
    this.fileFormat = document.querySelectorAll('a[href$=".pdf"], a[href$=".docx"], a[href$=".xlsx"], a[href$=".doc"], a[href$=".csv"]');
    this.phoneNumber = document.querySelectorAll('a[href^="tel:"]');
    this.email = document.querySelectorAll('a[href^="mailto:"]');
    this.socialMedias = document.querySelectorAll('#block-footersocialmedias .menu-item a, .node--type-detaillant .social-media-section a')
    this.navigationTableLinks = document.querySelectorAll('.detaillant-banner .banniere__nav a, .paragraph--type--banniere a.paragraph--type--element-de-navigation')
    this.articleList = document.querySelectorAll('.view-display-id-article_vedette .views-row a');
    this.articleRecomendationList = document.querySelectorAll('.view-display-id-article_super_vedette .views-row .views-field-title a, .view-display-id-article_promu .views-row .views-field-title a');
    this.megaMenuClickItem = document.querySelectorAll('.mm__level-1 .link-container a, .mm__level-2 a:not(.menu-level-1-title), .mm__level-3 .menu-item a , .mm__level-5-container a');
    this.footerMenuClickItem = document.querySelectorAll('.site-footer .region-footer-superior-left .menu-item a');
    this.rabbitholeClickItem = document.querySelectorAll('.paragraph--type--rabbit-hole .paragraph--type--rabbit-hole-item a');
    this.accordeonClickItem = document.querySelectorAll('.paragraph--type--accordeons .paragraph--type--accordeons-item button');
    this.InternalExternalLinkItem = document.querySelectorAll('.paragraph--type--contact-cards a, .paragraph--type--logo-blocks a, .paragraph--type--wysiwyg a');
    this.provinceInput = document.querySelectorAll('.block-sollio-custom-blocks-choose-province .province_input');
    this.banniereParagraph = document.querySelector('.paragraph--type--banniere .simple-breadcrumb');
    this.baseURL = window.location.protocol + "//" + window.location.hostname;
    this.init();
  }


  init() {
    this.pageView(); // UCS001 - page view
    this.viewRetailer(); // UCS003 - view retailer page
    this.addToWishList(); // UCS004 - add to wish list
    this.addToCart(); // UCS005 - interaction retailer form
    this.searchSuggestion(); // UCS007 - Search Suggestion
    this.searchResultEventListener(); // UCS007 - Search Results
    this.emailClick(); // UCS007 - Email Click
    this.navigationTable() // UCS007 - navigation table click
    this.socialMediaClick(); // UCS007 - Social media click
    this.phoneNumberClick(); // UCS007 - Phone number click
    this.ctaButtonClick(); // UCS007 - CTA/Button Click
    this.articleClickList(); // UCS007 - Article list click
    this.articleClickRecommendation(); // UCS007 - Article recommendation click
    this.megaMenuClick(); // UCS007 - Mega Menu click
    this.footerMenuClick(); // UCS007 - Footer Menu click
    this.rabbitHole(); // UCS007 - RabbitHole Click
    this.accordion(); // UCS007 - accordion Click
    this.internalExternalLink(); // UCS007 - Internal/External Click
    this.fileDownload(); // UCS008 - file download
    this.viewFolder(); // UCS011 - Bookmark list page load
    this.myRetailer(); // UCS012 - My Retailer/coop click
    this.searchSelection(); // UCS013 - Internal search
    this.filterSelection(); // UCS014 - Select filter
    this.myProvince(); // UCS018 - My Province
  }

  pageView() { // UCS001 - page view
    let selectedValue = 'CA';
    for (let i = 0; i < this.provinceInput.length; i++) {
      if (this.provinceInput[i].checked) {
        selectedValue = this.provinceInput[i].parentElement.getAttribute('data-province-code');
        break; // Exit the loop if a selected radio input is found
      }
    }

    const urlObject = new URL(window.location.href);
    const path = urlObject.pathname;
    const pathSegments = path.split('/').filter(segment => segment !== '');
    const result = pathSegments.map(segment => segment.replace(/-/g, ' '));

    this._push_custom_event_to_GA4({
      "event": "pageview",
      "event_name": "page_view",
      "page": {
        "page_language": document.documentElement.getAttribute("lang"),
        "content_type": document.getElementById('page-wrapper').getAttribute('data-content-type') || null,
        "page_category": document.getElementById('page-wrapper').getAttribute('data-page-category-first') || null,
        "page_category2": document.getElementById('page-wrapper').getAttribute('data-page-category-second') || null,
        "content_sector": document.getElementById('page-wrapper').getAttribute('data-content-sector') || null,
        "content_theme": document.getElementById('page-wrapper').getAttribute('data-content-theme') || null
      },
      "user": {
        "user_region": selectedValue
      }
    });
  }

  internalExternalLink() { // UCS007 - Internal Click
    if (this.InternalExternalLinkItem) {
      this.InternalExternalLinkItem.forEach(item => {
        item.addEventListener('click', (event) => {
          const href = item.getAttribute('href');
          const isInternal = this.isInternalLink(href);
          let type = 'lien interne'
          if (isInternal === false) {
            type = 'lien externe'
          }
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "click",
            "interaction": {
              "click_type": type,
              "link_url": this.baseURL + href,
              "link_text": item.textContent.trim(),
            }
          });
        });
      });
    }
  }

  rabbitHole() { // UCS007 - rabbit hole click
    if (this.rabbitholeClickItem) {
      this.rabbitholeClickItem.forEach(item => {
        item.addEventListener('click', (event) => {
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "click",
            "interaction": {
              "click_type": "rabbit hole",
              "link_url": this.baseURL + item.getAttribute('href'),
              "link_text": item.textContent.trim(),
            }
          });
        });
      });
    }
  }

  accordion() { // UCS007 -  accordion click
    if (this.accordeonClickItem) {
      this.accordeonClickItem.forEach(item => {
        item.addEventListener('click', (event) => {
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "click",
            "interaction": {
              "click_type": "accordéon",
              "link_url": "",
              "link_text": item.textContent.trim(),
            }
          });
        });
      });
    }
  }

  footerMenuClick() { // UCS007 -  footer Menu click
    if (this.footerMenuClickItem) {
      this.footerMenuClickItem.forEach(item => {
        item.addEventListener('click', (event) => {
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "click",
            "interaction": {
              "click_type": "footer",
              "link_url": this.baseURL + item.getAttribute('href'),
              "link_text": item.textContent.trim(),
            }
          });
        });
      });
    }
  }

  megaMenuClick() { // UCS007 -  Mega Menu click
    if (this.megaMenuClickItem) {
      this.megaMenuClickItem.forEach(item => {
        item.addEventListener('click', (event) => {
          let url = this.baseURL + item.getAttribute('href');
          if (event.target.parentElement.classList.contains('link-container') && event.target.closest("li").classList.contains('menuparent')) {
            url = null;
          }
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "click",
            "interaction": {
              "click_type": "méga menu",
              "link_url": url,
              "link_text": item.textContent.trim(),
            }
          });
        });
      });
    }
  }

  articleClickRecommendation() { // UCS007 - Article recommendation click
    if (this.articleRecomendationList) {
      this.articleRecomendationList.forEach(item => {
        item.addEventListener('click', (event) => {
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "click",
            "interaction": {
              "click_type": "boîte",
              "link_url": event.target.href,
              "link_text": event.target.textContent,
            }
          });
        });
      });
    }
  }

  articleClickList() { // UCS007 - Article list click
    if (this.articleList) {
      this.articleList.forEach(item => {
        item.addEventListener('click', (event) => {
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "click",
            "interaction": {
              "click_type": "liste",
              "link_url": event.target.href,
              "link_text": event.target.textContent,
            }
          });
        });
      });
    }
  }

  navigationTable() { // UCS007 - navigation table click
    if (this.navigationTableLinks) {
      this.navigationTableLinks.forEach(item => {
        item.addEventListener('click', (event) => {
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "click",
            "interaction": {
              "click_type": "navigation",
              "link_url": event.target.href,
              "link_text": event.target.textContent,
            }
          });
        });
      });
    }
  }

  socialMediaClick() { // UCS007 - social media click
    if (this.socialMedias) {
      this.socialMedias.forEach(item => {
        item.addEventListener('click', (event) => {
          let socialLink;
          if (item.textContent.trim() !== '') {
            socialLink = item.textContent.trim();
          } else {
            const spanElement = item.querySelector('span');
            socialLink = spanElement ? spanElement.textContent.trim() : '';
          }
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "click",
            "interaction": {
              "click_type": "réseau social",
              "link_url": item.getAttribute('href'),
              "link_text": socialLink,
            }
          });
        });
      });
    }
  }

  emailClick() { // UCS007 - Email Click
    if (this.email) {
      this.email.forEach(item => {
        item.addEventListener('click', (event) => {
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "click",
            "interaction": {
              "click_type": "adresse courriel",
              "link_url": event.target.href,
              "link_text": event.target.textContent,
            }
          });
        });
      });
    }
  }

  phoneNumberClick() { // UCS007 - Phone Number Click
    if (this.phoneNumber) {
      this.phoneNumber.forEach(item => {
        item.addEventListener('click', (event) => {
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "click",
            "interaction": {
              "click_type": "numéro de téléphone",
              "link_url": event.target.href,
              "link_text": event.target.textContent,
            }
          });
        });
      });
    }
  }

  viewRetailer() { // UCS003 - view retailer page
    if (this.viewRetailerPage) {
      this._pushRetailerDetailedPageInfo('view_item');
    }
  }

  addToWishList() { // UCS004 - add to wish list
    if (this.addtoWishListBtn) {
      this.addtoWishListBtn.querySelector('a').addEventListener('click', (event) => {
        if (!this.addtoWishListBtn.classList.contains('current')) {
          this._pushRetailerDetailedPageInfo('add_to_wishlist');
        }
      });
    }
  }

  addToCart() {  // UCS005 - add to cart
    if (this.retailerForm) {
      let isInteracted = false;
      const formTextFields = this.retailerForm.querySelectorAll('input, textarea');
      formTextFields.forEach(field => {
        field.addEventListener('keydown', (event) => {
          if (!isInteracted) {
            this._pushRetailerDetailedPageInfo('add_to_cart');
            isInteracted = true;
          }
        });
        field.addEventListener('change', (event) => {
          if (!isInteracted) {
            this._pushRetailerDetailedPageInfo('add_to_cart');
            isInteracted = true;
          }
        });
      });

      const selectInput = this.retailerForm.querySelectorAll('.select-selected');
      selectInput.forEach(field => {
        field.addEventListener('click', (event) => {
          if (!isInteracted) {
            this._pushRetailerDetailedPageInfo('add_to_cart');
            isInteracted = true;
          }
        });
      });
    }
  }

  fileDownload() { // UCS008 - file download

    if (this.fileDownloadPDF) {
      this.fileDownloadPDF.forEach(item => {
        item.addEventListener('click', (event) => {
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "file_download",
            "interaction": {
              "link_url": window.location.href,
              "link_text": null,
              "link_text_fr": null,
              "file_name": null,
              "file_extension": "pdf",
              "link_title" : document.getElementsByTagName("h1")[0] ? document.getElementsByTagName("h1")[0].textContent : null,
            }
          });
        });
      });
    }
    if (this.fileFormat) {
      this.fileFormat.forEach(item => {
        item.addEventListener('click', (event) => {
          const link = item.getAttribute("href");
          const filename = link.substring(link.lastIndexOf("/") + 1);
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "file_download",
            "interaction": {
              "link_url": link,
              "link_text": event.target.textContent.trim(),
              "link_title" : null,
              "file_name": filename,
              "file_extension": filename.substring(filename.lastIndexOf(".") + 1)
            }
          });
        });
      });
    }
  }

  viewFolder() { // UCS011 - Bookmark list page load
    if (this.viewFolderPage) {
      this._push_custom_event_to_GA4({
        "event": "pageview",
        "event_name": "view_folder"
      });
    }

    if (this.viewFolderCLick) {
      this.viewFolderCLick.forEach(item => {
        item.addEventListener('click', (event) => {
          this._push_custom_event_to_GA4({
            "event": "pageview",
            "event_name": "view_folder"
          });
        });
      });
    }
  }

  myRetailer() { // UCS012 - My Retailer/coop click
    if (this.findRetailer) {
      this.findRetailer.forEach(item => {
        item.addEventListener('click', (event) => {
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "select_my_retailer",
            "interaction": {
              "link_text": item.querySelector('span').textContent,
            }
          });
        });
      });
    }

    if (this.findRetailerPanel) {
      this.findRetailerPanel.querySelector(".currentRetailerLabel").addEventListener('click', (event) => {
        this._push_custom_event_to_GA4({
          "event": "user_interaction",
          "event_name": "select_my_retailer",
          "interaction": {
            "link_text": event.target.textContent,
          }
        });
      });
      this.findRetailerPanel.querySelectorAll(".retailer-section button").forEach(item => {
        item.addEventListener('click', (event) => {
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "select_my_retailer",
            "interaction": {
              "link_text": event.target.textContent,
            }
          });
        });
      });
    }

  }

  myProvince() { // UCS018 - My Province
    if (this.provinceSelector) {
      this.provinceSelector.forEach(item => {
        item.addEventListener('click', (event) => {
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "select_my_province",
            "interaction": {
              "link_text": item.parentNode.getAttribute('data-province-name'),
            }
          });
        });
      });
    }

    if (this.provinceSelectorMain) {
      this.provinceSelectorMain.addEventListener('click', (event) => {
        this._push_custom_event_to_GA4({
          "event": "user_interaction",
          "event_name": "select_my_province",
          "interaction": {
            "link_text": event.target.textContent.trim(),
          }
        });
      });
    }
  }

  ctaButtonClick() { // UCS007 - CTA/Button Click
    if (this.ctabuttonElements) {
      this.ctabuttonElements.forEach(item => {
        item.addEventListener('click', (event) => {
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "click",
            "interaction": {
              "click_type": 'bouton',
              "link_url": this.baseURL + item.getAttribute('href'),
              "link_text": item.textContent.trim(),
            }
          });
        });
      });
    }
  }

  searchSuggestion() {  // UCS007 - Search Suggestion
    if (this.searchSuggestions) {
      this.searchSuggestions.forEach(item => {
        item.addEventListener('click', (event) => { // add a click event listener to each a tag
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "click",
            "interaction": {
              "click_type": "suggestion de recherche",
              "link_url": event.target.href,
              "link_text": event.target.textContent,
            }
          });
        });
      });
    }
  }

  searchResultEventListener() // UCS007 - Search Results && Innovation
  {

    if (document.querySelectorAll('.search-results .views-row .search__link--full, .view-display-id-sollio_articles .views-row .views-field-title a')) {

      let type = "résultat de recherche";
      if (document.querySelector('body').classList.contains('page-node-type-innovation')) {
        type = 'boîte';
      }

      document.querySelectorAll('.search-results .views-row .search__link--full, .view-display-id-sollio_articles .views-row .views-field-title a').forEach(item => {
        item.addEventListener('click', (event) => { // add a click event listener to each a tag
          const parser = new DOMParser();
          this._push_custom_event_to_GA4({
            "event": "user_interaction",
            "event_name": "click",
            "interaction": {
              "click_type": type,
              "link_url": event.target.href,
              "link_text": parser.parseFromString('<!doctype html><body>' + event.target.textContent + '', 'text/html').body.textContent,
            }
          });
        });
      });

      const boundItemClickHandle = this.searchItemClickHandle.bind(this);
      document.addEventListener('searchResultsAjaxLoaded', () => {
        if (document.querySelectorAll('.search-results .views-row .search__link--full, .view-display-id-sollio_articles .views-row .views-field-title a')) {
          document.querySelectorAll('.search-results .views-row .search__link--full, .view-display-id-sollio_articles .views-row .views-field-title a').forEach(item => {
            let componentEvent = item._getEventListeners();
            //Only add events if no event listener on object
            if (!window.eventListener._hasEvents(componentEvent)) {
              item.addEventListener('click', boundItemClickHandle); // Add the event listener
            }
          });
        }
      });
    }
  }

  searchSelection() { // UCS013 - Internal search
    const params = new URLSearchParams(window.location.search);
    if (params.has("search") && this.bodyElement.classList.contains('page-node-type-recherche')) { // pour la searchpage
      const searchValue = decodeURIComponent(params.get("search"));
      const searchNbElement = document.getElementById("sr__counter");
      let searchNb = 0;
      if (searchNbElement) {
        searchNb = parseInt(document.getElementById("sr__counter").getAttribute("data-results"));
      }
      this._push_custom_event_to_GA4({
        "event": "user_interaction",
        "event_name": "view_search_results",
        "interaction": {
          "search_type": 'recherche générale', //"recherche détaillant | recherche proximité | recherche secteur d'activité | recherche générale"
          "search_term": searchValue,
          "search_results_count": searchNb
        }
      });
    }
  }

  filterSelection() { // UCS014 - Select filter
    if (this.bodyElement.classList.contains('page-node-type-recherche') || this.bodyElement.classList.contains('page-node-type-innovation')) { // pour la searchpage
      this.applyFacetsBtn.addEventListener('click', () => { // add a click event listener to each a tag
        const values = [];
        const newValues = [];
        const formats = [];
        document.querySelectorAll('.block-facets-summary span.facet-item__value').forEach((item) => {
          values.push(item.textContent);
        });

        this.checkboxFilterEvents(values, newValues, formats)

        this._push_custom_event_to_GA4({
          "event": "user_interaction",
          "event_name": "select_filter",
          "interaction": {
            "search_filter": newValues,
            "search_filter_type": formats,
            "search_filter_incremental": values.concat(newValues)
          }
        });
      });
    }
  }

  _push_custom_event_to_GA4(pushContent) {
    if (pushContent.length < 1) {
      console.error('Please specify at least the first parameter for eventName.');
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(pushContent);
  }


  searchItemClickHandle(event) {
    let type = "résultat de recherche";
    if (document.querySelector('body').classList.contains('page-node-type-innovation')) {
      type = 'boîte';
    }
    const parser = new DOMParser();
    this._push_custom_event_to_GA4({
      "event": "user_interaction",
      "event_name": "click",
      "interaction": {
        "click_type": type,
        "link_url": event.target.href,
        "link_text": parser.parseFromString('<!doctype html><body>' + event.target.textContent + '', 'text/html').body.textContent,
      }
    });
  }

  _pushRetailerDetailedPageInfo(event_name) {
    this._push_custom_event_to_GA4({
      "event": "ecom_interaction",
      "event_name": event_name,
      "ecommerce": {
        "items": [
          {
            "item_id": document.querySelector('.page-node-type-detaillant .choose-retailer-section .retailer__selector').getAttribute('data-retailer-id'),
            "item_name": document.querySelector('.page-node-type-detaillant .detaillant-contact').querySelector('h3').innerText,
            "item_category": "détaillant",
            "item_region": document.querySelector('.page-node-type-detaillant .detaillant-contact').getAttribute('data-region'),
            "quantity": 1,
            "index": 0
          }
        ]
      }
    });
  }

  checkboxFilterEvents(values, newValues, formats) {
    document.querySelectorAll('.facets-widget-checkbox').forEach(toggle => {
      toggle.querySelectorAll('.facets-checkbox').forEach(checkbox => {
        if (checkbox.checked) {
          const checkboxVal = checkbox.parentNode.querySelector('.facet-item__value').textContent;
          if (!values.includes(checkboxVal)) {
            newValues.push(checkboxVal);
            const format = checkbox.parentNode.closest('.facets-widget-checkbox').querySelector('h3').textContent;
            if (!formats.includes(format)) {
              formats.push(format);
            }
          }
        }
      });
    });
  }

  isInternalLink(href) {
    const link = new URL(href, window.location.href);
    return link.hostname === window.location.hostname;
  }
}

window.addEventListener('load', () => {
  new ga4();
});


